import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { orderBy } from 'lodash';
import storeLoader from 'app/stores/storeLoader';
import { Box, Button, Dialog, Select, Spinner, Text } from 'core/components';
import { showErrorToast } from 'core/components/toast';
import { persistHash } from 'app/stores/query/urlHash';

@storeLoader('$boards', '$savedViews')
@inject('$boards')
@withRouter
@observer
class AddToObservationDeckDialog extends Component {
  state = {
    selectedBoardId: '',
    isAdding: false
  };

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props;
    if (isOpen && !prevProps.isOpen) {
      this.setState({ selectedBoardId: '', isAdding: false });
    }
  }

  handleSelectBoard = (value) => {
    this.setState({ selectedBoardId: value });
  };

  handleSubmit = async () => {
    const { $boards, $savedViews, panelConfig: _panelConfig, history, onClose } = this.props;
    const { selectedBoardId } = this.state;
    const panelConfig = structuredClone(_panelConfig);
    this.setState({ isAdding: true });
    try {
      if (panelConfig.config.widgetName === 'savedViewBrowser' && panelConfig.config.hash) {
        // create saved view from hash
        const { title = 'Untitled Query' } = panelConfig;
        const { hash } = panelConfig.config;
        const savedView = $savedViews.collection.forge({ view_name: title, saved_query_id: hash });
        await Promise.all([savedView.save({}, { toast: false }), persistHash(hash)]);
        panelConfig.config.savedViewId = savedView.id;
        delete panelConfig.title;
        delete panelConfig.config.hash;
      }

      const board = await $boards.addPanelToPersonalBoard('home', panelConfig, {
        boardId: selectedBoardId || undefined
      });
      onClose();
      history.push(board.navigatePath);
    } catch (e) {
      showErrorToast('Failed to add panel to Observation Deck. Please try again.');
      this.setState({ isAdding: false });
    }
  };

  render() {
    const { $boards, panelConfig, isOpen, onClose, loading } = this.props;
    const { selectedBoardId, isAdding } = this.state;

    const boardOptions = orderBy(
      $boards.collection
        .get()
        .filter((b) => b.canEdit)
        .map((b) => b.selectOptionFormat),
      'label'
    );

    return (
      <Dialog title="Add to Observation Deck" isOpen={isOpen} onClose={onClose} canEscapeKeyClose canOutsideClickClose>
        <Dialog.Body>
          {loading ? (
            <Box display="flex" justifyContent="center" p={2}>
              <Spinner />
            </Box>
          ) : (
            <Box>
              <Text mb={1} as="div">
                Select an Observation Deck to add this view to:
              </Text>
              <Select
                options={boardOptions}
                values={selectedBoardId}
                onChange={this.handleSelectBoard}
                fill
                showFilter={boardOptions.length > 5}
                placeholder="Select an Observation Deck..."
              />
              {panelConfig?.config.widgetName === 'savedViewBrowser' && panelConfig.config.hash && (
                <Text as="div" mt="4px" fontSize="small" color="muted">
                  A Saved View will be created and added to your Library
                </Text>
              )}
            </Box>
          )}
        </Dialog.Body>
        <Dialog.Footer>
          <Button text="Cancel" onClick={onClose} mr={1} />
          <Button
            text="Add"
            intent="primary"
            onClick={this.handleSubmit}
            loading={isAdding}
            disabled={!selectedBoardId || loading}
          />
        </Dialog.Footer>
      </Dialog>
    );
  }
}

export default AddToObservationDeckDialog;
